<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <strong style="display: block;">{{ title }}</strong>
          <span class="title-filter" style="margin-left: 0px !important;" >Ngày nhận VB từ tòa: </span>
          <Calendar id="range" v-model="filterDate" selectionMode="range" :numberOfMonths="2" :manualInput="false" dateFormat="dd/mm/yy" :show-icon="true"/>
          <Button label="Tìm" @click="onEnter" class="p-button-success btn-enter-filter"/>
          <div class="box-selected-file" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.report_general_employee_inventory && this.$store.getters.group_permission.report_general_employee_inventory.export == true || this.$store.getters.role == 'admin'">
            <!-- <input type="file" name="exportFile" class="file" @change="onExportExcel"/>
            <span class="btn-span">Xuất Excel</span> -->
            <div class="opacity"/>
            <ExportExcel
              :fields="exportConfigs1.fields"
              :fetch="exportConfigs1.fetch"
              :colHeaderStyle="exportConfigs1.colHeaderStyle"
              :name="exportConfigs1.name"
              :getRowStyle="exportConfigs1.getRowStyle"
              :renderBody="
                exportConfigs1.renderBody ? exportConfigs1.renderBody : undefined
              "
            >
              <span class="btn-span">Xuất Excel</span>
            </ExportExcel>
          </div>
          
          <!-- <div class="box-export-report" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.detail_document.export == true || this.$store.getters.role == 'admin'">
            <div class="opacity"/>
            <ExportExcel
              :fields="exportConfigs.fields"
              :fetch="exportConfigs.fetch"
              :colHeaderStyle="exportConfigs.colHeaderStyle"
              :name="exportConfigs.name"
              :subTitle="exportConfigs.subTitle"
              :renderBody="
                exportConfigs.renderBody ? exportConfigs.renderBody : undefined
              "
              :renderHeader="
                exportConfigs.renderHeader ? exportConfigs.renderHeader : undefined
              "
            >
              <span class="btn-span">In biên bản giao nhận</span>
            </ExportExcel>
          </div> -->
          
        </div>
        
        <DataTable
          :value="listData"
          class="p-datatable-responsive"
          dataKey="id"
          :selection.sync="selectedRows"
          :paginator="pagination"
          :rows="paginationRows"
          :loading="loading"
          :filters="filters"
          :scrollable="(scrollHeight !== '' ? true : false) "
          :scrollHeight="scrollHeight"
          :autoLayout="true"
          :key="componentKey"
          :rowsPerPageOptions="rowsPerPageOptions"
          currentPageReportTemplate="Tổng TĐV: {totalRecords}"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          @filter="onFilter"
        >
          <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
          <Column 
            v-for="c in dataModel.getDisplayFields()"
            :key="c.key"
            :field="getField(c)"
            :header="getLabel(c)"
            :filterMatchMode="getFilterMatch(c)"
            :sortable="getSortable(c)"
            :bodyClass="(c.class ? 'txt-' + c.class : '')"
            :bodyStyle="getHeaderStyle(c)"
            :headerStyle="getHeaderStyle(c)"
            :headerClass="(c.class ? 'txt-' + c.class : '')"
          >
            <template #body="slotProps">
              <img
                v-if="getType(c) == 'Image'"
                :src="getData(c, slotProps.data)"
                style="width: 40px; heigth: 40px"
              />
              <div
                v-else-if="c.type == 'Text'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>
              <div
                v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>

              <Checkbox
                v-else-if="getType(c) == 'Checkbox'"
                v-model="slotProps.data[slotProps.column.field]"
                :binary="true"
                @change="onInputChange($event, slotProps.data, c)"
              />
              <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
            </template>
            <template v-if="c.filter" #filter>
              <InputText
                v-if="c.filter.type == 'input'"
                type="text"
                v-model="filters[c.key]"
                class="p-column-filter"
                :placeholder="getFilterPlaceHolder(c)"
              />
              <Dropdown
                :key="countDropdown"
                v-if="c.filter.type == 'select'"
                v-model="filters[getField(c)]"
                :options="getFilterOptions(c.key)"
                :optionLabel="c.filter.optionLabel"
                :optionValue="c.filter.optionKey"
                :placeholder="getFilterPlaceHolder(c)"
                class="p-column-filter"
                :showClear="true"
                appendTo="body"
              >
                <template #option="slotProps">
                  <div class="p-clearfix">
                    <span
                      :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                      >{{ slotProps.option[c.filter.optionLabel] }}</span
                    >
                  </div>
                </template>
              </Dropdown>
              <Calendar 
                v-if="c.filter.type == 'DateRange'"
                :showOnFocus="false" 
                :monthNavigator="true" 
                :yearNavigator="true" 
                yearRange="2000:2030" 
                dateFormat="yy-mm-dd" 
                id="date_from" 
                v-model="filters[getField(c)]" 
                class="p-column-filter"
                :showIcon="true" 
                selectionMode="range"
                appendTo="body"
                :showClear="true"
                @date-select="select_date($event,getField(c))"
                :manualInput="false"
                />
            </template>
          </Column>
          <template #empty>
            {{ $t('datatable.empty') }}
          </template>
          <template #loading>
            {{ $t('datatable.loading') }}
          </template>
          <template #footer>
            <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-top: 8px">
              <div style="min-width: 350px;">Tổng VB chưa chuyển hình thức trong hạn: {{ sum_vb_chua_chuyen_trong_han }}</div>
              <div style="min-width: 350px;">Tổng VB chưa chuyển hình thức trễ hạn: {{ sum_vb_chua_chuyen_tre_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ trực tiếp trong hạn: {{ sum_td_tructiep_trong_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ trực tiếp trễ hạn: {{ sum_td_tructiep_tre_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ trực tiếp có XN UB trong hạn: {{ sum_td_tructiep_ub_trong_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ trực tiếp có XN UB trễ hạn: {{ sum_td_tructiep_ub_tre_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ giao nhận trong hạn: {{ sum_td_giaonhan_trong_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ giao nhận trễ hạn: {{ sum_td_giaonhan_tre_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ NT3 trong hạn: {{ sum_td_nt3_trong_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ NT3 trễ hạn: {{ sum_td_nt3_tre_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ NT3 có XN UB trong hạn: {{ sum_td_nt3_ub_trong_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ NT3 có XN UB trễ hạn: {{ sum_td_nt3_ub_tre_han }}</div>
              <div style="min-width: 350px;">Tổng VB NY trong hạn: {{ sum_td_niemyet_trong_han }}</div>
              <div style="min-width: 350px;">Tổng VB NY trễ hạn: {{ sum_td_niemyet_tre_han }}</div>
              <div style="min-width: 350px;">Tổng VB TĐ Không thành trong hạn: {{ sum_td_khongthanh_trong_han }}</div>
              <div style="min-width: 350px;">Tổng VB Không thành trễ hạn: {{ sum_td_khongthanh_tre_han }}</div>
              <div style="min-width: 350px;">Tổng VB trả lại tòa ( loại 4 ): {{ sum_td_tralai_toa }}</div>
              <div style="min-width: 350px;">Tổng VB Tồn trong hạn: {{ sum_total_inventory_in }}</div>
              <div style="min-width: 350px;">Tổng VB Tồn trễ hạn: {{ sum_total_inventory_out }}</div>
              

            </div>
          </template>
        </DataTable>

        

        <Dialog
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xóa <strong>{{this.deleteName}}</strong>
          <template
            #footer
          >
            <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button
              label="Hủy"
              @click="showDeleteDialog = false"
              icon="pi pi-times"
              class="p-button-warning"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import gql from "graphql-tag";
import moment from "moment-timezone";
// import XLSX from "xlsx"
import graphql from '../common/graphql'
export default {
  components: {
  },
  data() {
    return {
      filterOptions: {},
      listData: [],
      options: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      totalDoc: 0,
      totalRemain: 0,
      totalComplete: 0,

      sum_vb_chua_chuyen_trong_han: 0,
      sum_vb_chua_chuyen_tre_han: 0,

      sum_td_tructiep_trong_han: 0,
      sum_td_tructiep_tre_han: 0,

      sum_td_tructiep_ub_trong_han: 0,
      sum_td_tructiep_ub_tre_han: 0,

      sum_td_giaonhan_trong_han: 0,
      sum_td_giaonhan_tre_han: 0,

      sum_td_nt3_trong_han: 0,
      sum_td_nt3_tre_han: 0,

      sum_td_nt3_ub_trong_han: 0,
      sum_td_nt3_ub_tre_han: 0,

      sum_td_niemyet_trong_han: 0,
      sum_td_niemyet_tre_han: 0,

      sum_td_khongthanh_trong_han: 0,
      sum_td_khongthanh_tre_han: 0,

      sum_td_tralai_toa: 0,

      sum_total_inventory_in: 0,
      sum_total_inventory_out: 0,

      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: 10, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      selectedRows: null,
      filterDate: null,
      dateFrom: null,
      dateTo: null,
      // EXPORT
      exportConfigs: {
        sheetInfo: 'CÔNG TY CỔ PHẦN ENGMA',
        header: 'DANH SÁCH VĂN BẢN',
        subTitle: (data) => {
          let subTitle = '';
          let dateFrom = '...';
          let dateEnd = '...';
          console.log(data);
          if (this.filterDate !== null) {
            dateFrom = moment(this.filterDate[0]).format('DD/MM/YYYY');
            dateEnd = this.filterDate[1] !== null ? moment(this.filterDate[1]).format('DD/MM/YYYY') : '...';
          }

          subTitle = `Từ ngày ${dateFrom} đến ngày ${dateEnd}`;
          return subTitle;
        },
        colHeaderStyle: 'background-color:#bfbfbf; font-weight: bold; border: solid 1px #fffff',
        // fields: {
        //   'STT': 'stt',
        //   'MÃ SỐ': 'code_system',
        //   'MÃ VĂN BẢN TÒA': 'code_court',
        //   'SỐ QĐ THA': 'number_decision',
        //   'NỘI DUNG VB': 'content_document',
        //   'NGÀY BAN HÀNH': {
        //     field: 'date_issued',
        //     callback: (value) => {
        //       if (value)
        //         return moment
        //           .utc(value)
        //           .clone()
        //           .tz('Asia/Ho_Chi_Minh')
        //           .format('DD/MM/YYYY');
        //     },
        //   },
        //   'NGÀY MỜI': {
        //     field: 'date_invite',
        //     callback: (value) => {
        //       if (value)
        //         return moment
        //           .utc(value)
        //           .clone()
        //           .tz('Asia/Ho_Chi_Minh')
        //           .format('DD/MM/YYYY');
        //     },
        //   },
        //   'TÊN': 'name_litigant',
        //   'ĐỊA CHỈ': 'address',
        //   'PHƯỜNG/ XÃ': {
        //     callback: (row) => {
        //       return row.ward.name
        //     }
        //   },
        //   'QUẬN/ HUYỆN': {
        //     callback: (row) => {
        //       return row.district.name
        //     }
        //   },
        //   'TP/ TỈNH': {
        //     callback: (row) => {
        //       return row.state.name
        //     }
        //   },
        //   'NGƯỜI KÝ': 'signer',
        //   'MÃ CƠ QUAN': 'code_agency',
        //   'NGÀY NHẬN TỪ TÒA': {
        //     field: 'date_receipt_court',
        //     callback: (value) => {
        //       if (value)
        //         return moment
        //           .utc(value)
        //           .clone()
        //           .tz('Asia/Ho_Chi_Minh')
        //           .format('DD/MM/YYYY');
        //     },
        //   },
        //   'GẤP': {
        //     callback: (row) => {
        //       if (row.is_urgent) {
        //         return 'Gấp';
        //       } else {
        //         return '';
        //       }
        //     }
        //   },
        //   'LOẠI': 'type_document',
        // },
        fetch: async () => {
          let data = [];
          let arrIDs = []
          if (this.selectedRows && this.selectedRows.length > 0) {
            for (let i = 0; i < this.selectedRows.length; i++) {
              arrIDs.push(this.selectedRows[i].id)
            }
          }
          if (arrIDs.length > 0) {
            let variables = {
              where: {
                id: {'_in': arrIDs}
              },
              orderBy: {id: 'asc'}
            }
            if (this.filterDate) {
              let date1 = new Date(this.filterDate[0]).toISOString()
              date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
              let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : '';
              date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
              Object.assign(variables, {date_from: date1, date_to: date2})
            }
            await this.$apollo.query({
              query: gql(graphql.GET_REPORT_DOCS_TDV),
              variables: variables,
              fetchPolicy: "no-cache"
            }).then(async (resData) => {
              // console.log("=============fetch data", resData)
              let lstdata = resData.data.users;
              for (let i = 0; i < lstdata.length; i++) {
                let user_info = {}
                let stt = 0;
                if (lstdata[i].view_tdv_total_doc_waiting_no_scan.length > 0) {
                  user_info.fullname = lstdata[i].fullname;
                  let documents = lstdata[i].view_tdv_total_doc_waiting_no_scan
                  for (let j = 0; j < documents.length; j++) {
                    stt += 1;
                    documents[j].document.fullname = lstdata[i].fullname;
                    documents[j].document.stt = stt;
                  }
                  let obj = [
                    user_info,
                    documents
                  ]
                  data.push(obj);
                } else {
                  user_info.fullname = lstdata[i].fullname;
                  let obj = [
                    user_info,
                    []
                  ]
                  data.push(obj);
                }
              }
            }).catch((error) => {
              console.log(error);
            });
            // console.log("Fecth return", data)
            if (data.length > 0) {
              this.selectedRows = null;
              this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất file excel thành công', life: 3000 })
              return data;
            } else {
              this.selectedRows = null;
              this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Không có văn bản giao nhận', life: 3000 })
              return data;
            }
          } else {
            this.selectedRows = null;
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng chọn ít nhất 1 Tống đạt viên', life: 3000 })
            return data;
          }
          
        },
        name: 'In biên bản giao nhận.xls',
        renderHeader: () => {
          return '';
        },
        renderBody: (data) => {
          // console.log('================', data);
          let body = '';
          let headerStyle = `background-color:#bfbfbf; font-weight: bold;`;
          let tHeader = `<tr>
            <th style="${headerStyle}">STT</th>
            <th style="${headerStyle}">MÃ SỐ</th>
            <th style="${headerStyle}">MÃ VĂN BẢN TÒA</th>
            <th style="${headerStyle}">SỐ QD THA</th>
            <th style="${headerStyle}">NỘI DUNG VĂN BẢN</th>
            <th style="${headerStyle}">NGÀY BAN HÀNH</th>
            <th style="${headerStyle}">NGÀY MỜI</th>
            <th style="${headerStyle}">TÊN</th>
            <th style="${headerStyle}">ĐỊA CHỈ</th>
            <th style="${headerStyle}">PHƯỜNG/ XÃ</th>
            <th style="${headerStyle}">QUẬN/ HUYỆN</th>
            <th style="${headerStyle}">TP/ TỈNH</th>
            <th style="${headerStyle}">NGƯỜI KÝ</th>
            <th style="${headerStyle}">MÃ CƠ QUAN</th>
            <th style="${headerStyle}">NGÀY NHẬN TỪ TÒA</th>
            <th style="${headerStyle}">GẤP</th>
            <th style="${headerStyle}">LOẠI</th>
          </tr>`;
          for (let i = 0; i < data.length; i++) {
            const d = data[i];
            let uinfo = d[0];
            let vbinfo = d[1];
            let subTable = `<tr><td colspan="4">Nhân viên: ${uinfo.fullname}</td></tr>
            ${tHeader}`;
            for (let i = 0; i < vbinfo.length; i++) {
              // console.log(vbinfo);
              const k = vbinfo[i].document;
              subTable += `<tr>
                <td>${k.stt}</td>
                <td>${(k.code_system) ? k.code_system:''}</td>
                <td>${(k.code_court) ? k.code_court:''}</td>
                <td>${(k.number_decision) ? k.number_decision:''}</td>
                <td>${(k.content_document) ? k.content_document:''}</td>
                <td>${(k.date_issued) ?  moment.utc(new Date(k.date_issued)).clone().tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY'):''}</td>
                <td>${(k.date_invite) ? moment.utc(new Date(k.date_invite)).clone().tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY'):''}</td>
                <td>${(k.name_litigant) ? k.name_litigant:''}</td>
                <td>${(k.address) ? k.address:''}</td>
                <td>${(k.ward) ? k.ward.name:''}</td>
                <td>${(k.district) ? k.district.name:''}</td>
                <td>${(k.state) ? k.state.name:''}</td>
                <td>${(k.signer) ? k.signer:''}</td>
                <td>${(k.code_agency) ? k.code_agency:''}</td>
                <td>${moment.utc(new Date(k.date_receipt_court)).clone().tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY')}</td>
                <td>${k.is_urgent && 'Gấp' || ''}</td>
                <td>${(k.type_document) ? k.type_document:''}</td>
              </tr>`;
            }
            body += subTable + '<tr></tr>';
          }
          return body;
        },
      },
      exportConfigs1: {
        sheetInfo: 'CÔNG TY CỔ PHẦN ENGMA',
        header: 'DANH SÁCH VĂN BẢN',
        getRowStyle: (row) => {
          if (row._style) {
           return 'font-weight: bold; background-color: #f5f5f5;';
          }
          return 'font-weight: bold; background-color: #f5f5f5;';
        },
        // subTitle: () => {
        //   let subTitle = '';
        //   let dateFrom = '...';
        //   let dateEnd = '...';
        //   // console.log(data);
        //   if (this.filterDate !== null) {
        //     dateFrom = moment(this.filterDate[0]).format('DD/MM/YYYY');
        //     dateEnd = this.filterDate[1] !== null ? moment(this.filterDate[1]).format('DD/MM/YYYY') : '...';
        //   }

        //   subTitle = `Từ ngày ${dateFrom} đến ngày ${dateEnd}`;
        //   return subTitle;
        // },
        colHeaderStyle: 'background-color:#bfbfbf; font-weight: bold; border: solid 1px #fffff',
        fields:{},
        // fields: {
        //   'STT  ': 'stt',
        //   "MÃ NHÂN VIÊN": 'code',
        //   'TÊN NHÂN VIÊN': {
        //     key: 'fullname',
        //     callback: (row) => row.fullname,
        //     style: (row) => row._style
        //   },
        //   "MÃ KHU VỰC": {
        //     callback: (row) => {
        //       return row?.areas?.name ?? '';
        //     }
        //   },
        //   'TỔNG VB NHẬN CHƯA SCAN ( TỔNG VB ĐÃ XÁC NHẬN)': {
        //     callback: (row) => {
        //       return row?.total_received_documents_not_scanned?.aggregate?.count ?? 0;
        //     }
        //   },
        //   'TỔNG SỐ VB ĐANG TĐ': {
        //     callback: (row) => {
        //       return row?.total_number_of_documents_being_served?.aggregate?.count ?? 0;
        //     }
        //   },
        //   'TỔNG SỐ VB ĐÃ TRẢ ĐPV': {
        //     callback: (row) => {
        //       return row?.total_docs_sent_back_to_unit?.aggregate?.count ?? 0;
        //     }
        //   },
        //   'TỔNG SỐ VB ĐPV ĐÃ NHẬN': {
        //     callback: (row) => {
        //       return row?.total_documents_received_by_coordinator?.aggregate?.count ?? 0;
        //     }
        //   },
        //   'TỔNG SỐ VB HOÀN THIỆN LẠI': {
        //     callback: (row) => {
        //       return row?.total_documents_resubmitted?.aggregate?.count ?? 0;
        //     },
        //   },
        //   'TỔNG SỐ VB HOÀN THÀNH': {
        //     callback: (row) => {
        //       return row?.total_documents_completed?.aggregate?.count ?? 0;
        //     },
        //   },
        //   'TỔNG SỐ VB ĐÃ TRẢ CƠ QUAN': {
        //     callback: (row) => {
        //       return row?.total_docs_returned_to_agency?.aggregate?.count ?? 0;
        //     }
        //   },
        //   'TỔNG SỐ VB ĐÃ TÍNH LƯƠNG': {
        //     callback: (row) => {
        //       return row?.total_documents_processed_for_salary?.aggregate?.count ?? 0;
        //     }
        //   },
        //   'TỔNG VB': {
        //     callback: (row) => {
        //       return this.calculate_total_doc_sum(row);
        //     }
        //   },
        //   'TỔNG VB HOÀN THÀNH': {
        //     callback: (row) => {
        //       return this.calculate_total_doc_done_sum(row);
        //     }
        //   },
        //   'TỔNG TỒN': {
        //     callback: (row) => {
        //       return this.calculate_total_inventory(row);
        //     }
        //   },
        //   'GHI CHÚ': 'note',
        // },
      
        fetch: async () => {
          //let data = [];
          let arrIDs = []
          if (this.selectedRows && this.selectedRows.length > 0) {
            console.log("selectedRows",this.selectedRows);
            for (let i = 0; i < this.selectedRows.length; i++) {
              arrIDs.push(this.selectedRows[i].id)
            }
          }
          if (arrIDs.length > 0) {
            let variables = {
              where: {
                id: {'_in': arrIDs}
              },
              orderBy: {id: 'asc'}
            }
            if (this.filterDate) {
              let date1 = new Date(this.filterDate[0]).toISOString()
              date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
              let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : '';
              date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
              Object.assign(variables, {date_from: date1, date_to: date2})
            }
            // 
            console.log("Fecth return", arrIDs)
            if (arrIDs.length > 0) {
              // var that =this
              // setTimeout(() => {
              //   that.selectedRows = null;
              //    that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất file excel thành công', life: 3000 })
              // }, 2000);
              return this.selectedRows;
            } else {
              //this.selectedRows = null;
              this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Không có văn bản giao nhận', life: 3000 })
              return this.selectedRows;
            }
          } else {
            //this.selectedRows = null;
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng chọn ít nhất 1 Tống đạt viên', life: 3000 })
            return this.selectedRows;
          }
          
        },
        name: 'Xuất Excel.xls',
        renderHeader: () => {
          return '';
        },
          renderBody: (data) => {
          console.log('data5544:',data);
          let html = '';

          // Render subTitle (dùng <td>, không <th>)
          if (this.filterDate !== null) {
            const dateFrom = moment(this.filterDate[0]).format('DD/MM/YYYY');
            const dateEnd = this.filterDate[1] ? moment(this.filterDate[1]).format('DD/MM/YYYY') : '...';
            html += `
              <tr>
                <td colspan="16" style="font-size:14px; text-align:left; font-weight:bold;">
                  Từ ngày ${dateFrom} đến ngày ${dateEnd}
                </td>
              </tr>
            `;
          }

          var data_convert = [];
          var sum_vb_chua_chuyen_trong_han = 0;
            var sum_vb_chua_chuyen_tre_han = 0;
            var sum_td_tructiep_trong_han = 0;
            var sum_td_tructiep_tre_han = 0;
            var sum_td_tructiep_ub_trong_han = 0;
            var sum_td_tructiep_ub_tre_han = 0;
            var sum_td_giaonhan_trong_han = 0;
            var sum_td_giaonhan_tre_han = 0;
            var sum_td_nt3_trong_han = 0;
            var sum_td_nt3_tre_han = 0;
            var sum_td_nt3_ub_trong_han = 0;
            var sum_td_nt3_ub_tre_han = 0;
            var sum_td_niemyet_trong_han = 0;
            var sum_td_niemyet_tre_han = 0;
            var sum_td_khongthanh_trong_han = 0;
            var sum_td_khongthanh_tre_han = 0;
            var sum_td_tralai_toa = 0;
            var sum_total_inventory_in = 0;
            var sum_total_inventory_out = 0;
            var selectedRowsConvert =  this.$commonFuction.convertJsonObject(this.selectedRows);
          for (let i = 0; i < selectedRowsConvert.length; i++) {
            var item = selectedRowsConvert[i];
            item.stt = i + 1;
            data_convert.push(item);
            sum_vb_chua_chuyen_trong_han += item?.vb_chua_chuyen_trong_han ?? 0;
            sum_vb_chua_chuyen_tre_han += item?.vb_chua_chuyen_tre_han ?? 0;
            sum_td_tructiep_trong_han += item?.td_tructiep_trong_han ?? 0;
            sum_td_tructiep_tre_han += item?.td_tructiep_tre_han ?? 0;
            sum_td_tructiep_ub_trong_han += item?.td_tructiep_ub_trong_han ?? 0;
            sum_td_tructiep_ub_tre_han += item?.td_tructiep_ub_tre_han ?? 0;
            sum_td_giaonhan_trong_han += item?.td_giaonhan_trong_han ?? 0;
            sum_td_giaonhan_tre_han += item?.td_giaonhan_tre_han ?? 0;
            sum_td_nt3_trong_han += item?.td_nt3_trong_han ?? 0;
            sum_td_nt3_tre_han += item?.td_nt3_tre_han ?? 0;
            sum_td_nt3_ub_trong_han += item?.td_nt3_ub_trong_han ?? 0;
            sum_td_nt3_ub_tre_han += item?.td_nt3_ub_tre_han ?? 0;
            sum_td_niemyet_trong_han += item?.td_niemyet_trong_han ?? 0;
            sum_td_niemyet_tre_han += item?.td_niemyet_tre_han ?? 0;
            sum_td_khongthanh_trong_han += item?.td_khongthanh_trong_han ?? 0;
            sum_td_khongthanh_tre_han += item?.td_khongthanh_tre_han ?? 0;
            sum_td_tralai_toa += item?.td_tralai_toa ?? 0;
            sum_total_inventory_in += item?.total_inventory_in ?? 0;
            sum_total_inventory_out += item?.total_inventory_out ?? 0;
          }
          var data_footer = {
            _style: 'font-weight: bold;',
              stt: '',
            fullname: 'Tổng cộng',
            id: '',
            code: '',
            area_id: '',
            vb_chua_chuyen_trong_han:sum_vb_chua_chuyen_trong_han,
            vb_chua_chuyen_tre_han: sum_vb_chua_chuyen_tre_han,
            td_tructiep_trong_han: sum_td_tructiep_trong_han,
            td_tructiep_tre_han: sum_td_tructiep_tre_han,
            td_tructiep_ub_trong_han: sum_td_tructiep_ub_trong_han,
            td_tructiep_ub_tre_han: sum_td_tructiep_ub_tre_han,
            td_giaonhan_trong_han: sum_td_giaonhan_trong_han,
            td_giaonhan_tre_han: sum_td_giaonhan_tre_han,
            td_nt3_trong_han: sum_td_nt3_trong_han,
            td_nt3_tre_han: sum_td_nt3_tre_han,
            td_nt3_ub_trong_han: sum_td_nt3_ub_trong_han,
            td_nt3_ub_tre_han: sum_td_nt3_ub_tre_han,
            td_niemyet_trong_han: sum_td_niemyet_trong_han,
            td_niemyet_tre_han: sum_td_niemyet_tre_han,
            td_khongthanh_trong_han: sum_td_khongthanh_trong_han,
            td_khongthanh_tre_han: sum_td_khongthanh_tre_han,
            td_tralai_toa: sum_td_tralai_toa,
            total_inventory_in: sum_total_inventory_in,
            total_inventory_out: sum_total_inventory_out,
            note: '',
          };

          // Header
          html += `
            <tr style="background-color:#bfbfbf; font-weight:bold;">
              <td>STT</td>
              <td>MÃ NHÂN VIÊN</td>
              <td>TÊN NHÂN VIÊN</td>
              <td>MÃ KHU VỰC</td>
              <td>Tổng vb chưa chuyển hình thức trong hạn</td>
              <td>Tổng vb chưa chuyển hình thức trễ hạn</td>
              <td>Tổng vb TĐ trực tiếp trong hạn</td>
              <td>Tổng vb TĐ trực tiếp trễ hạn</td>
              <td>Tổng vb TĐ trực tiếp có XN UB trong hạn</td>
              <td>Tổng vb TĐ trực tiếp có XN UB trễ hạn</td>
              <td>Tổng vb TĐ giao nhận trong hạn</td>
              <td>Tổng vb TĐ giao nhận trễ hạn</td>
              <td>Tổng vb TĐ NT3 trong hạn</td>
              <td>Tổng vb TĐ NT3 trễ hạn</td>
              <td>Tổng vb TĐ NT3 có XN UB trong hạn</td>
              <td>Tổng vb TĐ NT3 có XN UB trễ hạn</td>
              <td>Tổng vb NY trong hạn</td>
              <td>Tổng vb NY trễ hạn</td>
              <td>Tổng vb TĐ Không thành trong hạn</td>
              <td>Tổng vb Không thành trễ hạn</td>
              <td>Tổng vb trả lại tòa ( loại 4 )</td>
              <td>Tổng vb Tồn trong hạn</td>
              <td>Tổng vb Tồn trễ hạn</td>
              <td>GHI CHÚ</td>
            </tr>
          `;

          // Render body rows
          var stt = 0;
          console.log('data33:',data_convert);

          data_convert.forEach((item) => {
            //console.log('item:',item);
            stt += 1;
            html += `
              <tr style="${item._style || ''}">
                <td>${stt}</td>
                <td>${item.code ?? ''}</td>
                <td>${item.fullname ?? ''}</td>
                <td>${item.area_name ?? ''}</td>
                <td>${item.vb_chua_chuyen_trong_han ?? 0}</td>
                <td>${item.vb_chua_chuyen_tre_han ?? 0}</td>
                <td>${item.td_tructiep_trong_han ?? 0}</td>
                <td>${item.td_tructiep_tre_han ?? 0}</td>
                <td>${item.td_tructiep_ub_trong_han ?? 0}</td>
                <td>${item.td_tructiep_ub_tre_han ?? 0}</td>
                <td>${item.td_giaonhan_trong_han ?? 0}</td>
                <td>${item.td_giaonhan_tre_han ?? 0}</td>
                <td>${item.td_nt3_trong_han ?? 0}</td>
                <td>${item.td_nt3_tre_han ?? 0}</td>
                <td>${item.td_nt3_ub_trong_han ?? 0}</td>
                <td>${item.td_nt3_ub_tre_han ?? 0}</td>
                <td>${item.td_niemyet_trong_han ?? 0}</td>
                <td>${item.td_niemyet_tre_han ?? 0}</td>
                <td>${item.td_khongthanh_trong_han ?? 0}</td>
                <td>${item.td_khongthanh_tre_han ?? 0}</td>
                <td>${item.td_tralai_toa ?? 0}</td>
                <td>${item.total_inventory_in ?? 0}</td>
                <td>${item.total_inventory_out ?? 0}</td>
                <td>${item.note ?? ''}</td>
              </tr>
            `;
          });

          html += `
              <tr style="${data_footer._style || ''}">
                <td></td>
                <td></td>
                <td>${data_footer.fullname ?? ''}</td>
                <td></td>
                <td>${data_footer.vb_chua_chuyen_trong_han ?? 0}</td>
                <td>${data_footer.vb_chua_chuyen_tre_han ?? 0}</td>
                <td>${data_footer.td_tructiep_trong_han ?? 0}</td>
                <td>${data_footer.td_tructiep_tre_han ?? 0}</td>
                <td>${data_footer.td_tructiep_ub_trong_han ?? 0}</td>
                <td>${data_footer.td_tructiep_ub_tre_han ?? 0}</td>
                <td>${data_footer.td_giaonhan_trong_han ?? 0}</td>
                <td>${data_footer.td_giaonhan_tre_han ?? 0}</td>
                <td>${data_footer.td_nt3_trong_han ?? 0}</td>
                <td>${data_footer.td_nt3_tre_han ?? 0}</td>
                <td>${data_footer.td_nt3_ub_trong_han ?? 0}</td>
                <td>${data_footer.td_nt3_ub_tre_han ?? 0}</td>
                <td>${data_footer.td_niemyet_trong_han ?? 0}</td>
                <td>${data_footer.td_niemyet_tre_han ?? 0}</td>
                <td>${data_footer.td_khongthanh_trong_han ?? 0}</td>
                <td>${data_footer.td_khongthanh_tre_han ?? 0}</td>
                <td>${data_footer.td_tralai_toa ?? 0}</td>
                <td>${data_footer.total_inventory_in ?? 0}</td>
                <td>${data_footer.total_inventory_out ?? 0}</td>
                <td>${data_footer.note ?? ''}</td>
              </tr>
            `;
            this.selectedRows = null;
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất file excel thành công', life: 3000 })
                  
          return html;
        },
      },
    }
  },
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel('report_general_employee_inventory')
    this.title = this.dataModel.label
    this.$store.commit('setLoading', true);
    // if(this.$route.params.reload) {
    //   window.location.reload();
    // }
    this.loading = false;
    this.countDropdown++;
    // this.$apollo.queries.listData.refresh();
    await this.onCreated();
    this.callbackOptions();
  },
  mouted() {
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    calculate_total_doc_done_sum(row) {
      //console.log("row111", row)
      // var col_total_received_documents_not_scanned = row?.total_received_documents_not_scanned?.aggregate?.count ?? 0;
      // var col_total_number_of_documents_being_served = row?.total_number_of_documents_being_served?.aggregate?.count ?? 0;
      // var col_total_docs_sent_back_to_unit = row?.total_docs_sent_back_to_unit?.aggregate?.count ?? 0;
      // var col_total_documents_resubmitted = row?.total_documents_resubmitted?.aggregate?.count ?? 0;
      
      var col_total_documents_completed = row?.total_documents_completed?.aggregate?.count ?? 0;
      var col_total_docs_returned_to_agency = row?.total_docs_returned_to_agency?.aggregate?.count ?? 0;
      var col_total_documents_processed_for_salary = row?.total_documents_processed_for_salary?.aggregate?.count ?? 0;
     // console.log("col_total_documents_processed_for_salary", col_total_documents_processed_for_salary)
      var total_doc_sum = col_total_documents_completed+col_total_docs_returned_to_agency+col_total_documents_processed_for_salary   
     // console.log("total_doc_sum", total_doc_sum)
      return total_doc_sum
    },
    calculate_total_doc_sum(row) {
      //console.log("row111", row)
      var col_total_received_documents_not_scanned = row?.total_received_documents_not_scanned?.aggregate?.count ?? 0;
      var col_total_number_of_documents_being_served = row?.total_number_of_documents_being_served?.aggregate?.count ?? 0;
      var col_total_docs_sent_back_to_unit = row?.total_docs_sent_back_to_unit?.aggregate?.count ?? 0;
      var col_total_documents_received_by_coordinator = row?.total_documents_received_by_coordinator?.aggregate?.count ?? 0;
      var col_total_documents_resubmitted = row?.total_documents_resubmitted?.aggregate?.count ?? 0;
      var col_total_documents_completed = row?.total_documents_completed?.aggregate?.count ?? 0;
      var col_total_docs_returned_to_agency = row?.total_docs_returned_to_agency?.aggregate?.count ?? 0;
      var col_total_documents_processed_for_salary = row?.total_documents_processed_for_salary?.aggregate?.count ?? 0;
     // console.log("col_total_documents_processed_for_salary", col_total_documents_processed_for_salary)
      var total_doc_sum = col_total_received_documents_not_scanned+col_total_number_of_documents_being_served+col_total_docs_sent_back_to_unit+col_total_documents_received_by_coordinator+col_total_documents_resubmitted+col_total_documents_completed+col_total_docs_returned_to_agency+col_total_documents_processed_for_salary   
     // console.log("total_doc_sum", total_doc_sum)
      return total_doc_sum
    },
    //tổng tồn
    calculate_total_inventory(row) {
       // = E6+F6+G6+H6-I6-J6-K6
      var col_total_received_documents_not_scanned = row?.total_received_documents_not_scanned?.aggregate?.count ?? 0;
      var col_total_number_of_documents_being_served = row?.total_number_of_documents_being_served?.aggregate?.count ?? 0;
      var col_total_docs_sent_back_to_unit = row?.total_docs_sent_back_to_unit?.aggregate?.count ?? 0;
      var col_total_documents_received_by_coordinator = row?.total_documents_received_by_coordinator?.aggregate?.count ?? 0;
      var col_total_documents_resubmitted = row?.total_documents_resubmitted?.aggregate?.count ?? 0;
      // var col_total_documents_completed = row?.total_documents_completed?.aggregate?.count ?? 0;
      // var col_total_docs_returned_to_agency = row?.total_docs_returned_to_agency?.aggregate?.count ?? 0;
      // var col_total_documents_processed_for_salary = row?.total_documents_processed_for_salary?.aggregate?.count ?? 0;
      var total_inventory = col_total_received_documents_not_scanned+col_total_number_of_documents_being_served+col_total_docs_sent_back_to_unit+col_total_documents_received_by_coordinator+col_total_documents_resubmitted;   
      return total_inventory;
    },
    onFilter(e){
      /*console.log("eeeeeeeeeeeeeeeeeeeeee:",e);*/
      if (e.filteredValue){
        this.renderSummary(e.filteredValue)
      }else{
         this.renderSummary([])
      }

    },
     renderSummary(listData){
        this.sum_vb_chua_chuyen_trong_han = 0;
        this.sum_vb_chua_chuyen_tre_han = 0;
        this.sum_td_tructiep_trong_han = 0;
        this.sum_td_tructiep_tre_han = 0;
        this.sum_td_tructiep_ub_trong_han = 0;
        this.sum_td_tructiep_ub_tre_han = 0;
        this.sum_td_giaonhan_trong_han = 0;
        this.sum_td_giaonhan_tre_han = 0;
        this.sum_td_nt3_trong_han = 0;
        this.sum_td_nt3_tre_han = 0;
        this.sum_td_nt3_ub_trong_han = 0;
        this.sum_td_nt3_ub_tre_han = 0;
        this.sum_td_niemyet_trong_han = 0;
        this.sum_td_niemyet_tre_han = 0;
        this.sum_td_khongthanh_trong_han = 0;
        this.sum_td_khongthanh_tre_han = 0;
        this.sum_td_tralai_toa = 0;
        this.sum_total_inventory_in = 0;
        this.sum_total_inventory_out = 0;
        for (let index = 0; index < listData.length; index++) {
          const item = listData[index];
          this.sum_vb_chua_chuyen_trong_han += item.vb_chua_chuyen_trong_han || 0;
          this.sum_vb_chua_chuyen_tre_han += item.vb_chua_chuyen_tre_han || 0;
          this.sum_td_tructiep_trong_han += item.td_tructiep_trong_han || 0;
          this.sum_td_tructiep_tre_han += item.td_tructiep_tre_han || 0;
          this.sum_td_tructiep_ub_trong_han += item.td_tructiep_ub_trong_han || 0;
          this.sum_td_tructiep_ub_tre_han += item.td_tructiep_ub_tre_han || 0;
          this.sum_td_giaonhan_trong_han += item.td_giaonhan_trong_han || 0;
          this.sum_td_giaonhan_tre_han += item.td_giaonhan_tre_han || 0;
          this.sum_td_nt3_trong_han += item.td_nt3_trong_han || 0;
          this.sum_td_nt3_tre_han += item.td_nt3_tre_han || 0;
          this.sum_td_nt3_ub_trong_han += item.td_nt3_ub_trong_han || 0;
          this.sum_td_nt3_ub_tre_han += item.td_nt3_ub_tre_han || 0;
          this.sum_td_niemyet_trong_han += item.td_niemyet_trong_han || 0;
          this.sum_td_niemyet_tre_han += item.td_niemyet_tre_han || 0;
          this.sum_td_khongthanh_trong_han += item.td_khongthanh_trong_han || 0;
          this.sum_td_khongthanh_tre_han += item.td_khongthanh_tre_han || 0;
          this.sum_td_tralai_toa += item.td_tralai_toa || 0;
          this.sum_total_inventory_in += item.total_inventory_in || 0;
          this.sum_total_inventory_out += item.total_inventory_out || 0;
        }
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields()
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_status = {}
          var tableName = element.models.tableName
          if (tableName == 'area'){
            where_status.deleted = {_eq: false};
          }
          var {data} = await this.$apollo.query({
            query: DataServices.getList(tableName, {"fields" : attributes.join(',')}),
            variables: {where_key : where_status}
          })
         /* console.log("datadatadatadata:",data);
          console.log("datadatadatadata:",element.models.tableName);*/
          if (data) {
            /*console.log("1111111111111111111111:",attributes[1]);*/
            var result = data[Object.keys(data)];
            /*console.log("222222222222222:",attributes[0]);*/
            if (result) {
              for (let index = 0; index < result.length; index++) {
                const ele = result[index];
                optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
              }
            }
          }
          /*console.log("elementelementelementelement:",element.key);
          console.log("datadatadatadata:",optionsData);*/
          this.options[element.key] = optionsData;
          /*console.log("datadatadatadata:",optionsData);
          console.log("element.key:",element.key);*/
        }
        this.componentKey++;
      }
    },
    async onCreated() {
       var dataPost = {};
  if (this.filterDate !== null) {
    let date1 = new Date(this.filterDate[0]).toISOString()
    this.dateFrom = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
    let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1;
    this.dateTo = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
    dataPost.date_from = this.dateFrom;
    dataPost.date_to = this.dateTo;
  }

  // const limit = 50; // lấy mỗi lần 100 bản ghi
  // let offset = 0;
  // let hasMore = true;
  let allUsers = [];

  this.$store.commit('setLoading', true);

  try {

   
    const headers = {
      "Authorization": "Bearer " + this.$store.getters.token,
    };
    var res = await this.$CoreService.callApiPost('/_api/common/report_general_employee_inventory',dataPost, headers)
    allUsers = res.data.data   
    console.log("allUsers:",allUsers);
    // Xử lý dữ liệu tổng hợp sau khi đã load xong tất cả
    this.listData = allUsers;
    this.renderSummary(allUsers)
    console.log("allUsers:",allUsers);
    this.dataModel.processData(this.listData);
  } catch (error) {
    if (error.graphQLErrors?.[0]?.extensions?.code === 'invalid-jwt') {
      this.$router.go(0);
    }
    console.error(error);
  } finally {
    this.$store.commit('setLoading', false);
  }
},
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel('report_general_employee_inventory');
      // console.log(this.dataModel)
      this.title = this.dataModel.label;
    },
    async onEnter() {
      if (this.filterDate !== null) {
        this.$store.commit('setLoading', true);
        let date1 = new Date(this.filterDate[0]).toISOString()
        this.dateFrom = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1
        this.dateTo = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
        await this.onCreated();
      }
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // actions.header = { name: 'add', icon: 'plus', path: `import-document/add`};
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        // buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-manager/view/`};
        buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-document/edit/`},
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async actionsClicked(key, action, data) {
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    deleteData() {
      this.showDeleteDialog = false
      var query = DataServices.deleteData(this.modelName)
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        }
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(res => {
        if (res.data.delete_document.affected_rows > 0) {
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        } else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
        this.$apollo.queries.listData.refresh()
      }).catch((error) => {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xóa dữ liệu gặp vấn đề', life: 3000 })
        console.error('ERROR: ', error)
      });
    },
    onExportReport() {
      console.log('Xuat report: ', this.selectedRows)
    },
    onExportExcel(e) {
      console.log('Xuat excel: ', this.selectedRows)
      this.$store.commit("setLoading", true);
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      if (files[0].name.split('.').pop() !== 'xlsx' && files[0].name.split('.').pop() !== 'XLSX') {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng nhập file có định dạng xlsx', life: 3000 })
        return
      }
      this.$store.commit("setLoading", false);
    },
    // GỘP HÀM
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm:ss DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          /*console.log("this.optionsthis.optionsthis.optionsthis.options:",row)
          console.log("this.optionsthis.optionsthis.optionsthis.col.keycol.keycol.key:",col.key)*/
          lists = this.options[col.key];
          /*console.log("listslistslistslists111:",lists);
          console.log("rowrowrowrowrowrowrow:",row);*/
        }
        //value = "testss"
        if (lists && lists.length) {
          /*console.log("listslists:",lists);*/
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      } 
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn ${this.getLabel(col).toLowerCase()}`;
      } else if (col.filter.type == "input") {
        return `Nhập ${this.getLabel(col).toLowerCase()}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    }
  },
  apollo: {
    // listData: {
    //   query() {
    //     this.modelName = this.$route.meta.model;
    //     return DataServices.getList(this.modelName);
    //   },
    //   variables: {
    //     where_key: {
    //       users_account: {
    //         role: {_eq: "tdv"},
    //         deleted: {_eq: false}
    //       }, 
    //       deleted: {_eq: false}
    //     }
    //   },
    //   update(data) {
    //     this.title = this.dataModel.label + ' '
    //     this.dataModel.processData(listData)
    //     this.$store.commit('setLoading', false);
    //     this.componentKey += 1
    //     if (Object.keys(data).length > 0) {
    //       var listData = data[this.dataModel.tableName]
    //       this.totalDoc = data.users.length;
    //       return data[this.dataModel.tableName]
    //     }
    //   },
    //   fetchPolicy: 'network-only',
    //   error() {
    //     this.$store.commit('setLoading', false);
    //   },
    //   skip() {
    //     return !this.modelName
    //   }
    // }
  }

}
</script>
<style lang="scss">
.p-calendar .p-datepicker { padding: 0px !important; min-width: 100% !important;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {
  border-right: 1px solid #d8dae2 !important;
  padding-left: 0.857rem !important;
  padding-right: 0.857rem !important;
  background: #fff !important;
}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {
  border: 1px solid #c8c8c8 !important;
}
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    .title-filter {
      margin-left: 24px;
    }
    .btn-enter-filter {
      background-color: #0A84FF !important;
      margin-left: 10px;
      padding: 6px 30px;
    }
  }
}
.box-selected-file {
  // padding: 10px; 
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
}
.box-selected-file span {
  padding: 7px 15px; 
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF; 
  border-radius: 3px; 
  cursor: pointer;
  font-size: 0.875rem;
  color: #ffffff;
  .btn-span {
    background: #0A84FF 0% 0% no-repeat padding-box !important;
    border: 1px solid #0A84FF;
  }
}
.box-export-report {
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
  span {
    padding: 7px 15px; 
    background: #0A84FF 0% 0% no-repeat padding-box;
    border: 1px solid #0A84FF; 
    border-radius: 3px; 
    cursor: pointer;
    font-size: 0.875rem;
    color: #ffffff;
  }
}
</style>